export enum PaymentForm {
  Efectivo = 1,
  Cheque = 2,
  Transferencia = 3,
  TarjetaCredito = 4,
  TarjetaDebito = 28,
}
